// Christmas Theme Configuration
export const christmasTheme = {
  id: 'christmas',
  name: 'Christmas',
  colors: {
    primary: '#C41E3A',
    secondary: '#165B33',
    accent: '#FFFFFF'
  },
  confetti: {
    enabled: true,
    colors: ['#C41E3A', '#165B33', '#FFFFFF', '#FFD700'],
    count: 60,
    shapes: ['snowflake']
  },
  fireworks: {
    enabled: false
  },
  banner: {
    enabled: true,
    text: '🎄 Merry Christmas! 🎅',
    backgroundColor: 'linear-gradient(135deg, #C41E3A 0%, #165B33 100%)'
  },
  particles: {
    snowflakes: true,
    bells: true
  }
};
